<template>
  <div class="nav-margin billing-page">
    <navigation />

    <div class="experience-switch" v-if="!bannerDismissed">
      <div class="experience-msg">
        <span class="experience-pill">New</span>
        <span class="experience-text">You're using the new plan &amp; billing page.</span>
      </div>
      <div class="experience-actions">
        <button type="button" class="experience-link experience-link-btn" v-b-modal="'feedbackModal-newBilling'">Give feedback</button>
      </div>
      <button
        type="button"
        class="experience-close"
        @click="dismissBanner"
        aria-label="Dismiss banner"
        title="Dismiss"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>

    <feedbackModal
      name="feedbackModal-newBilling"
      campaign-key="new-billing-v1"
      title="How's the new billing page?"
      subtitle="Your take helps us decide what to improve."
      scale-question="How would you rate the new billing experience?"
      :scale-min="1"
      :scale-max="7"
      scale-low-label="Not great"
      scale-high-label="Excellent"
      text-prompt="What's working or not working?"
      text-placeholder="Tell us anything that helps."
      submit-label="Send feedback"
    />

    <pricePlan v-if="!subscriptionState.isLifeTime" />
    <productCodeRedemption v-if="!!subscriptionState.isLifeTime" />
  </div>
</template>

<script>
import pricePlan from "../components/settings/setting-pricePlan.vue";
import productCodeRedemption from "../components/settings/setting-productCodeRedemption.vue";

export default {
  components: {
    pricePlan,
    productCodeRedemption,
  },
  data() {
    let dismissed = false;
    try {
      dismissed = window.localStorage.getItem("experience-banner::billing::dismissed") === "1";
    } catch (e) {
      // localStorage unavailable
    }
    return {
      user: this.$A.Auth,
      bannerDismissed: dismissed,
    };
  },
  computed: {
    subscriptionState: function() {
      return _.get(this.user, 'account.subscriptionState', {});
    }
  },
  mounted() {
    if (this.$route.path.includes('cancel')) {
      this.$router.replace('/billing');
    }
  },
  methods: {
    dismissBanner() {
      this.bannerDismissed = true;
      try {
        window.localStorage.setItem("experience-banner::billing::dismissed", "1");
      } catch (e) {
        // localStorage unavailable
      }
    },
  },
};
</script>

<style scoped>
.billing-page {
  min-height: 100vh;
  background: #f4f5f7;
}

/* Experience banner (same pattern as Overview / Profile) */
.experience-switch {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  column-gap: 16px;
  row-gap: 4px;
  padding: 8px 48px;
  background: rgba(1, 146, 86, 0.06);
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  font-size: 13px;
  color: #4b5563;
}
.experience-msg,
.experience-actions {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.experience-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  background: #019256;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  border-radius: 999px;
  letter-spacing: 0.02em;
}
.experience-text {
  color: #4b5563;
}
.experience-link {
  color: #019256;
  font-weight: 600;
  text-decoration: none;
}
.experience-link:hover {
  text-decoration: underline;
  color: #017a48;
}
.experience-link-btn {
  background: transparent;
  border: 0;
  padding: 0;
  font: inherit;
  cursor: pointer;
}
.experience-close {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: #6b7280;
  cursor: pointer;
  transition: background-color 120ms ease, color 120ms ease;
}
.experience-close:hover {
  background: rgba(15, 23, 42, 0.06);
  color: #111827;
}
</style>
